<template>
  <section class="auth-page">
    <div class="auth-shell gt-card">
      <aside class="auth-brand">
        <div class="brand-badge">GT</div>
        <h1>Gestion Total</h1>
        <p>Base SaaS modular para empresas, sucursales y modulos contratables.</p>
      </aside>

      <main class="auth-form">
        <span class="gt-pill">Acceso seguro</span>
        <h2>Iniciar sesion</h2>
        <p class="gt-muted">Entra para seleccionar empresa, sucursal y modulos activos.</p>

        <form @submit.prevent="handleLogin">
          <label class="gt-label" for="email">Correo electronico</label>
          <input id="email" v-model.trim="email" class="gt-input" type="email" placeholder="correo@empresa.com" autocomplete="email" />

          <label class="gt-label" for="password">Contrasena</label>
          <input id="password" v-model="password" class="gt-input" type="password" placeholder="********" autocomplete="current-password" />

          <button class="gt-button primary" type="submit" :disabled="loading">
            {{ loading ? 'Entrando...' : 'Iniciar sesion' }}
          </button>
        </form>

        <p class="footer-link">Nuevo en Gestion Total? <router-link to="/registrarse">Crear cuenta</router-link></p>
        <p v-if="error" class="error">{{ error }}</p>
      </main>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'UserLogin',
  data() {
    return { email: '', password: '', loading: false, error: '' };
  },
  methods: {
    ...mapActions(['login']),
    async handleLogin() {
      this.error = '';
      if (!this.email || !this.password) {
        this.error = 'Escribe tu correo y contrasena.';
        return;
      }
      this.loading = true;
      try {
        const data = await this.login({ email: this.email, password: this.password });
        this.$router.push(data.next_route || '/dashboard');
      } catch (error) {
        this.error = error.response?.data?.error || 'No se pudo iniciar sesion.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-page { min-height: 100vh; display: grid; place-items: center; padding: 2rem; }
.auth-shell { width: min(1040px, 100%); min-height: 650px; display: grid; grid-template-columns: .95fr 1.05fr; overflow: hidden; }
.auth-brand {
  padding: 3rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: linear-gradient(135deg, var(--gt-primary), #315d89);
  color: #fff;
}
.brand-badge { width: 4rem; height: 4rem; border-radius: 22px; display: grid; place-items: center; background: rgba(255,255,255,.18); font-weight: 900; font-size: 1.2rem; margin-bottom: auto; }
.auth-brand h1 { font-size: clamp(2.3rem, 5vw, 4.2rem); line-height: .95; margin: 0 0 1rem; }
.auth-brand p { max-width: 29rem; color: rgba(255,255,255,.78); font-size: 1.05rem; }
.auth-form { padding: 3rem; display: flex; flex-direction: column; justify-content: center; }
h2 { font-size: 2.1rem; margin: 1rem 0 .35rem; }
form { display: grid; gap: .8rem; margin-top: 1.5rem; }
.gt-button { width: 100%; margin-top: .8rem; }
.footer-link { margin-top: 1.4rem; color: var(--gt-muted); }
.footer-link a { color: var(--gt-primary); font-weight: 900; }
.error { background: #fff0ec; color: var(--gt-danger); padding: .85rem 1rem; border-radius: 16px; font-weight: 800; }
@media (max-width: 820px) { .auth-shell { grid-template-columns: 1fr; } .auth-brand { min-height: 260px; } }
</style>
